import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SideAccessory } from '../builders/KE_builder/side_accessories/side_accessory';
import { BuilderService } from '../SERVICES/BuilderService';
import { SceneService } from 'modules/scene-setup/scene.service';
import { numberToHexString } from '../helpers';
import { Curtain } from '../builders/KE_builder/side_accessories/curtain';

@Component({
  selector: 'app-curtain-settings',
  templateUrl: './curtain-settings.component.html',
  styleUrls: ['./curtain-settings.component.scss'],
})
export class CurtainSettingsComponent {
  @Input() panel: SideAccessory | null;
  @Input() index: number;
  @Input() moduleIndex: number;
  @Input() singleModule: boolean;

  @Output() deleted: EventEmitter<void> = new EventEmitter<void>();

  public closingType: string = 'Levo';
  public allTypes: string[] = ['Levo', 'Desno'];
  public selectedColor: string;

  constructor(public builderService: BuilderService, private sceneService: SceneService) {}

  public get moduleName(): string {
    const moduleNames = ['A', 'B', 'C', 'D'];
    return moduleNames[this.moduleIndex];
  }

  public get moduleSideName(): string {
    const moduleNames = ['spredaj', 'desno', 'zadaj', 'levo'];
    return moduleNames[this.index];
  }

  public get colorOptions(): string[] {
    const colorStringArr: string[] = [];
    this.builderService.sceneBuilder.getCurtainColors().forEach((color) => {
      if (this.panel && this.panel.getColor() === color) this.selectedColor = numberToHexString(color.code);
      colorStringArr.push(numberToHexString(color.code));
    });
    return colorStringArr;
  }

  removeCurtain() {
    if (this.panel) {
      this.builderService.sceneBuilder.removePanel(this.panel);
      this.sceneService.sceneController.requestRenderIfNotRequested();
      this.deleted.emit();
    }
  }

  changeColor(index: number) {
    if (this.panel) {
      this.builderService.sceneBuilder.changeCurtainColor(
        this.panel as Curtain,
        this.builderService.sceneBuilder.getCurtainColors()[index]
      );
      this.sceneService.sceneController.requestRenderIfNotRequested();
    }
  }

  updateClosingType() {
    if (this.panel) {
      this.builderService.sceneBuilder.updateCurtainClosingType(this.panel as Curtain, this.closingType);
      this.sceneService.sceneController.requestRenderIfNotRequested();
    }
  }

  itemClick(evt: MouseEvent) {
    evt.stopPropagation();
    if ((evt as PointerEvent).pointerId === -1) return;

    const elements = document.querySelectorAll('mat-expansion-panel-header');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    elements.forEach((el: any) => {
      if (evt.currentTarget !== el && (el as HTMLDivElement).classList.contains('mat-expanded')) el.click();
    });

    const opened = (evt.currentTarget as HTMLDivElement).classList.contains('mat-expanded');

    if (!opened) {
      const side = this.builderService.sceneBuilder.getPanelSide(this.panel);
      if (side !== undefined) {
        this.builderService.sceneBuilder.focusElement(this.panel, side, this.sceneService.sceneController);
        this.sceneService.sceneController.requestRenderIfNotRequested();
      }
    }
  }
}
